import { render, staticRenderFns } from "./pushchannelmanage.vue?vue&type=template&id=9aebd216&scoped=true&"
import script from "./pushchannelmanage.vue?vue&type=script&lang=js&"
export * from "./pushchannelmanage.vue?vue&type=script&lang=js&"
import style0 from "./pushchannelmanage.vue?vue&type=style&index=0&id=9aebd216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aebd216",
  null
  
)

export default component.exports